import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const AgreementLetterLazy = lazyLoader(
  () => import('./AgreementLetter' /* webpackChunkName: "agreement-letter" */),
);

const AgreementLetter = () => {
  return (
    <Suspense fallback={null}>
      <AgreementLetterLazy />
    </Suspense>
  );
};

export default AgreementLetter;
